import { FC } from "react";
import { LP_BORDER, LP_TEXT } from "./legalProtectionTheme";

interface LegalProtectionPanelDividerProps {
  /** What the form below holds: « ou saisir la filiale », « Filiale sélectionnée »… */
  label: string;
}

/**
 * Textual separator between the search insert and the form of a legal protection panel. It says
 * which of the two ways the panel is on, so that a picked company does not read as a second form.
 */
export const LegalProtectionPanelDivider: FC<LegalProtectionPanelDividerProps> = ({ label }) => (
  <div className="flex items-center gap-4">
    <span aria-hidden="true" className={`h-0 flex-1 border-t ${LP_BORDER.card}`} />
    <span className={`text-[12px] font-bold uppercase tracking-[0.08em] ${LP_TEXT.secondary}`}>{label}</span>
    <span aria-hidden="true" className={`h-0 flex-1 border-t ${LP_BORDER.card}`} />
  </div>
);
